<template>
  <el-popover
    :visible-arrow="false"
    placement="bottom-start"
    popper-class="condition-filters-popper"
    width="350"
    v-model="visible">
    <p class="title">条件检索</p>
    <form @submit.prevent="submit">
      <slot v-bind:condition="condition"></slot>
      <div class="actions">
        <div class="row">
          <div class="label"></div>
          <div class="cont">
            <el-button type="primary" size="mini" native-type="submit">确定</el-button>
            <el-button size="mini" @click="visible = false">取消</el-button>
          </div>
        </div>
      </div>
    </form>
    <el-button slot="reference" size="mini" type="default">按条件筛选</el-button>
  </el-popover>
</template>

<script>
  import _ from 'lodash'
  export default {
    props: {
      model: {
        required: true
      }
    },
    data () {
      return {
        condition: {},
        visible: false
      }
    },
    methods: {
      submit () {
        this.$emit('submit', this.condition)
      },
      close () {
        this.visible = false
      }
    },
    watch: {
      visible (val) {
        if (val) {
          this.condition = _.cloneDeep(this.model) || {}
        }
      }
    }
  }
</script>
